import React from 'react';
import PropTypes from 'prop-types';

import TextError from '../TextError/TextError';
import { IconCross } from '../../assets/icon';

const Input = ({
  type, value, placeholder, onChange, errorText,
  name, onBlur, disabled, inputStyle, containerStyle,
  leftIcon, isClearable, step, multiline, rows, min,
  max, autocomplete, autoFocus, infoText, onInfoClick
}) => {
  const Container = multiline ? 'textarea' : 'input';
  const baseInputClasses = `
    w-full px-[16px] py-[8px] bg-input-bg border border-input-bg rounded-[6px]
    text-text-main box-border text-[13px] font-medium font-sans
    placeholder:text-text-muted placeholder:font-normal
    focus:outline-none focus:bg-input-focus
    dark:bg-[#1b263b] dark:border-[#1b263b] dark:text-secondary dark:focus:bg-[#415a77]
  `;
  const stateClasses = `
    ${disabled ? 'opacity-40' : ''}
    ${leftIcon ? 'pl-[34px]' : ''}
    ${isClearable ? 'pr-[34px]' : ''}
  `;
  return (
    <div className={`flex flex-col items-center justify-center relative ${containerStyle || ''}`}>
      {leftIcon && <div className="absolute left-[8px] top-1/2 -translate-y-1/2 flex">{leftIcon}</div>}
      <Container
        className={`${baseInputClasses} ${stateClasses} ${inputStyle || ''}`}
        type={type}
        step={step}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        name={name}
        onBlur={onBlur}
        disabled={disabled}
        rows={rows}
        min={min}
        max={max}
        autoComplete={autocomplete ? 'on' : 'off'}
        autoFocus={autoFocus}
      />
      {isClearable && !!value?.length
        && (
        <div
          className="absolute right-[8px] top-1/2 -translate-y-1/2 flex items-center cursor-pointer
          w-[16px] h-[16px] hover:text-primary-hover"
          role="presentation"
          onClick={() => onChange({ target: { value: '' } })}
        >
          <IconCross />
        </div>
        )}
      {errorText && <TextError text={errorText} />}
      {infoText && (
        <span
          className="text-[10px] cursor-pointer text-info"
          role="presentation"
          onClick={onInfoClick}
        >
          {infoText}
        </span>
      )}
    </div>
  );
};

Input.propTypes = {
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  placeholder: PropTypes.string,
  errorText: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  onInfoClick: PropTypes.func,
  disabled: PropTypes.bool,
  inputStyle: PropTypes.string,
  containerStyle: PropTypes.string,
  infoText: PropTypes.string,
  isClearable: PropTypes.bool,
  multiline: PropTypes.bool,
  leftIcon: PropTypes.shape({}),
  step: PropTypes.number,
  rows: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  autocomplete: PropTypes.bool,
  autoFocus: PropTypes.bool,
};

Input.defaultProps = {
  type: 'text',
  placeholder: '',
  name: '',
  inputStyle: '',
  containerStyle: '',
  isClearable: false,
  errorText: undefined,
  disabled: false,
  multiline: false,
  onBlur: () => {},
  onInfoClick: () => {},
  leftIcon: undefined,
  step: 1,
  rows: 3,
  min: 0,
  max: undefined,
  autocomplete: true,
  autoFocus: false,
  infoText: undefined,
};

export default Input;
